module.exports = __webpack_public_path__ + "img/cooperation_unit_18.f44159bb.jpg";